import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BrushRulerIcon = createIcon({
  displayName: 'BrushRulerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M6.96608,20.28818l-2.722.68049a1.00009,1.00009,0,0,1-1.21279-1.21279l.68217-2.72869a2.677,2.677,0,0,1,2.60277-2.02775l.00695,0a2.683,2.683,0,0,1,2.67734,2.68427h0A2.6859,2.6859,0,0,1,6.96608,20.28818Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.27,12.79,3.3,7.82a1.026,1.026,0,0,1,0-1.45L6.37,3.3a1.026,1.026,0,0,1,1.45,0l4.73,4.73"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.97,11.45l4.73,4.73a1.026,1.026,0,0,1,0,1.45L17.63,20.7a1.026,1.026,0,0,1-1.45,0l-4.97-4.97"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.78,15.04a30.80906,30.80906,0,0,1,4.99977-6.26023c4.03075-4.03075,8.06849-6.52814,9.01855-5.57809S19.251,8.18948,15.22,12.22a30.79668,30.79668,0,0,1-6.26,5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const BrushRuler: FC<IconProps> = (props) => {
  return <CustomIcon as={BrushRulerIcon} {...props} />
}

export default memo(BrushRuler)
